import { Form } from 'antd';
import React from 'react';
import {
  DatePickerCustom,
  enumTypePicker,
} from '../../../../../../../components/DatePickerCustom';
import FilterDropdownField from '../../../../../shared/ui/FilterDropdownField/FilterDropdownField';

const PeriodSelection = ({ rangeFieldConfig, dateReangeConfig }) => {
  return (
    <div>
      <FilterDropdownField config={rangeFieldConfig} />

      <Form.Item
        label="Дата"
        style={{ margin: 0 }}
      >
        <DatePickerCustom
          value={dateReangeConfig.value}
          onChange={dateReangeConfig.onChange}
          typePicker={enumTypePicker.RANGE}
          size="large"
          placeholder={['ДД.ММ.ГГГГ', 'ДД.ММ.ГГГГ']}
          style={{ width: '100%' }}
        />
      </Form.Item>
    </div>
  );
};

export default PeriodSelection;
